import React, { useState } from 'react';
import './SubmitBanner.css';

export default function SubmitBanner({ onSubmit, onClose }) {
    const [isChecked, setIsChecked] = useState(false);

    const handleButtonClick = () => {
        if (isChecked) {
            onSubmit();
        }
    };

    return (
        <div className="submit-banner-calendar">
            <button className="banner-calendar-close" onClick={onClose}>✕</button>
            <div className="banner-calendar-content">
                <div className='banner-calendar-left'>
                    <div className="banner-calendar-checkbox-wrapper">
                        <input
                            type="checkbox"
                            id="calendar-submit-check"
                            className="banner-calendar-checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                        />
                    </div>
                    <label htmlFor="calendar-submit-check" className="banner-calendar-text">
                        Please check the box and submit if your tuition month is complete.
                    </label>
                </div>
                <button
                    className={`banner-calendar-submit ${!isChecked ? 'disabled' : ''}`}
                    onClick={handleButtonClick}
                    disabled={!isChecked}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}